export default class {
  init() {
    const $elements = $("[data-timeline]");

    if ($elements.length) {
      (async () => {
        const throttle = (await import("lodash/throttle")).default;

        [...$elements].forEach((timeline) => {
          const $progressBar = $(timeline).find("[data-timeline-progress]");

          $(window).on(
            "scroll",
            throttle(() => {
              const scrolled = $(window).scrollTop();
              const initialPosition = $progressBar.offset().top;
              const height = scrolled - initialPosition + $(window).height() / 2;
              $progressBar.css({ height });

              [...$(timeline).find("[data-timeline-item]")].forEach((el) => {
                $(el).toggleClass("active", scrolled + $(window).height() / 2 >= $(el).offset().top);
              });
            }, 50),
          );
        });
      })();
    }
  }
}
